import React from 'react';

const styles: Record<string, React.CSSProperties> = {
  cardActionArea: {
    padding: 24,
  },
  title: {
    maxWidth: '40%',
    wordBreak: 'break-word',
    marginBottom: 4,
  },
};

export default styles;
